export default __webpack_public_path__ + "static/media/channel_locations.915c50ec.webp";